module.exports = __webpack_public_path__ + "static/media/calendar.dc75fe96.svg";